import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/support-meeting/calendar',
            name: 'supportMeetingCalendar',
            meta: {
                showNavbar: false
            },
            component: () => import("./supportMeetingCalendar.vue")
        },
        {
            path: '/support-meeting/confirm',
            name: 'supportMeetingConfirm',
            meta: {
                showNavbar: false
            },
            component: () => import("./supportMeetingConfirm.vue")
        },
        {
            path: '/support-meeting/:identifier',
            name: 'supportMeetingDetail',
            meta: {
                showNavbar: false
            },
            component: () => import("./supportMeetingDetail.vue")
        },
    ];
};
